export default function PageLoading() {
  return (
    <main className="min-h-[70vh] bg-background flex items-center justify-center" aria-live="polite" aria-busy="true">
      <div className="flex flex-col items-center gap-4">
        <div className="h-1 w-16 bg-brand-yellow animate-pulse" />
        <p className="text-sm font-semibold uppercase tracking-[0.2em] text-muted-foreground">Loading ARCONDES</p>
      </div>
    </main>
  );
}
